<template>
  <v-app :lang="$i18n.locale">
    <v-overlay :value="loading">
      <v-sheet justify-center align-center outlined color="transparent">
        <v-progress-circular indeterminate :size="50">
        </v-progress-circular> </v-sheet
    ></v-overlay>
    <v-main>
      <section class="backoffice__layout">
        <div class="backoffice__sidebar">
          <nav class="sidebar">
            <div class="sidebar__logo">
              <v-img :src="require('../../assets/schooney_logo.png')" />
            </div>
            <div class="sidebar__title">
              <p>{{ $t("message.common.sidebar.application_form") }}</p>
            </div>
            <v-list>
              <v-list-item
                :key="item.to"
                v-for="(item, i) of sidebarList"
                class="menu"
                :class="{
                  'menu-active': activeSidebarIndex == i,
                }"
                @click="onChangeSidebar(item.to, i)"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </nav>
        </div>
        <div class="backoffice__main">
          <div class="top-bar">
            <ul class="breadcrumb">
              <li
                @click="goBack(item.link, item.onClick)"
                class="link"
                :class="{
                  'link--disable': !item.link || item.link == $route.fullPath,
                }"
                :key="`breadcrumb-${i}`"
                v-for="(item, i) in breadcrumb"
              >
                {{ item.text }}
                <span v-if="i + 1 !== breadcrumb.length">/&nbsp;</span>
              </li>
            </ul>
            
            <div class="top-bar__menu">
              <div class="line-oa-tutorial" @click="goToLineOA">
                <img src="../../assets/line-app.png" alt="line-oa">
                <span>Add LINE OA</span>
              </div>
              <a
                @click="changeLocale('th')"
                :class="{ 'link--active': $i18n.locale === 'th' }"
                >ไทย</a
              >
              <div class="divider divider--vertical divider--half"></div>
              <a
                @click="changeLocale('en')"
                :class="{ 'link--active': $i18n.locale === 'en' }"
                >EN</a
              >
              <div class="divider divider--vertical"></div>
              <v-menu
                v-model="showMenu"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <a class="icon-circle" v-bind="attrs" v-on="on">
                    <v-icon>mdi-apps</v-icon>
                  </a>
                </template>
                <v-card class="dropdown-menu" elevation="0">
                  <a
                    class="dropdown-menu-item"
                    @click="switchSystem('SCHOONEY_OTHER')">
                    <span
                      class="icon-circle icon--white icon-circle--gray icon-circle--xl"
                    >
                    <v-img :src="require('../../assets/schooney_icon.svg')" style="max-width: 30px;"/>
                    </span>
                    {{ $t("message.common.top_menu.other_system") }}
                  </a>
                  <a
                    v-if="permission.isSchoOlBus"
                    class="dropdown-menu-item"
                    @click="switchSystem('SCHOONEY_BUS')">
                    <span
                      class="icon-circle icon--white icon-circle--yellow icon-circle--xl"
                    >
                      <v-icon color="white" style="font-size: 25px;">mdi-bus</v-icon></span
                    >{{ $t("message.common.top_menu.schoolbus_system") }}
                  </a>
                  <a
                    v-if="permission.isSchoOlApplication"
                    class="dropdown-menu-item"
                    @click="switchSystem('SCHOONEY_APPLICATION')">
                    <span
                      class="icon-circle icon--white icon-circle--purple icon-circle--xl"
                    >
                      <v-icon color="white" style="font-size: 25px;">mdi-account-check</v-icon> </span
                    >{{ $t("message.common.top_menu.application_form") }}
                  </a>
                  <a
                    v-if="permission.isSchoOlTuition"
                    class="dropdown-menu-item"
                    @click="switchSystem('SCHOONEY_TUITION')">
                    <span
                      class="icon-circle icon--white icon-circle--brown icon-circle--xl"
                    >
                      <v-icon color="white" style="font-size: 25px;">mdi-cash-multiple</v-icon> </span
                    >{{ $t("message.common.top_menu.tuition_payment") }}
                  </a>
                </v-card>
              </v-menu>
              <v-badge bordered color="#00C487" dot offset-x="8" offset-y="8">
                <v-menu v-model="showProfileMenu" absolute offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <div class="user__avatar">
                      <span class="user__badge" />
                      <a
                        class="icon-circle icon-circle--orange"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <img src="../../assets/user-icon.svg" />
                      </a>
                    </div>
                  </template>
                  <v-card class="dropdown-menu-list" elevation="0">
                    <ul>
                      <li>
                        <a><v-icon>mdi-account</v-icon>{{ username }}</a>
                      </li>
                      <li>
                        <a @click="goResetPassword()">{{ $t("message.adminPage.changePassword") }}</a>
                      </li>
                      <li>
                        <a @click="goLogout()">{{ $t("message.adminPage.logout") }}</a>
                      </li>
                    </ul>
                  </v-card>
                </v-menu>
              </v-badge>
            </div>
          </div>
          <div class="backoffice__header">
            {{ title }}
          </div>

          <div class="backoffice__body">
            <slot> </slot>
          </div>
        </div>
      </section>
    </v-main>
  </v-app>
</template>

<script>
import i18n from "@/i18n";
import router from "@/router";
export default {
  name: "BackofficeLayout",
  components: {},
  computed: {
    isHaveParams() {
      let paramsList = this.$route.params;
      let key = Object.keys(paramsList);
      if (key.length > 0) return true;
      return false;
    },
    sidebarList() {
      return [
        {
          icon: "mdi-file",
          title: this.$t("message.common.sidebar.set_up_application_form"),
          to: "/registration/form",
        },
        {
          icon: "mdi-account-multiple",
          title: this.$t("message.common.sidebar.list_of_applicants"),
          to: "/registration/calendar",
        },
        {
          icon: "mdi-account-plus",
          title: this.$t("message.common.sidebar.list_of_qualified_applicants"),
          to: "/registration/qualified",
        },
      ];
    },
  },

  props: {
    title: {
      type: String,
      default: "",
    },
    breadcrumb: {
      type: Array,
    },
    loading: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.getCurrentSidebar();
    this.getSwitchSystemList()
  },

  data() {
    return {
      activeSidebarName: null,
      showMenu: false,
      showProfileMenu: false,
      activeSidebarIndex: 0,
      appUrl: {},
      permission: {},
      username: '',
      switchType: {
        SCHOONEY_OTHER: 'SCHOONEY_OTHER',
        SCHOONEY_BUS: 'SCHOONEY_BUS',
        SCHOONEY_APPLICATION: 'SCHOONEY_APPLICATION',
        SCHOONEY_TUITION: 'SCHOONEY_TUITION'
      }
    };
  },

  methods: {
    onChangeSidebar(url, i) {
      this.activeSidebarIndex = i;

      router.push(url);
    },
    goBack(url, onClick) {
      if (onClick) {
        onClick();
        return;
      }
      if (window.history?.state?.back) {
        router.back();
      } else {
        router.push(url);
      }
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
    },
    getCurrentSidebar() {
      try {
        let currentPath = this.$route.path;
        let listOfCurrentPath = currentPath.split("/");
        let subStringOfMainRoute = `/${listOfCurrentPath[1]}/${listOfCurrentPath[2]}`;
        let pathHeader = {
          "/registration/form": {
            name: i18n.t("message.adminPage.setupApp"),
            i: 0,
          },
          "/registration/calendar": {
            name: i18n.t("message.adminPage.listApp"),
            i: 1,
          },
          "/registration/qualified": {
            name: i18n.t("message.adminPage.listQualified"),
            i: 2,
          },
        };

        this.activeSidebarIndex = pathHeader[subStringOfMainRoute].i;
        this.activeSidebarName = pathHeader[subStringOfMainRoute].name;
      } catch (error) {
        return "";
      }
    },
    async getSwitchSystemList () {
      this.permission = JSON.parse(localStorage.getItem('Permission'))
      this.appUrl = JSON.parse(localStorage.getItem('AppUrl'))
      this.username = localStorage.getItem('username')

      // Deprecated since required data already been save in localStorage since redirect
      // this.isSubmitting = true
      // const res = await services.getSwitchSystemList()
      // if (res && res.data && res.data.status && res.data.status.code === 0) {
      //   const data = res.data.data.data
      //   this.permission = data.data
      //   this.appUrl = data.appUrl
      //   this.isSubmitting = false
      // } else {
      //   this.isSubmitting = false
      //   alert('error')
      // }
    },
    async switchSystem (type) {
      let appUrl = null
      this.showMenu = false
      switch (type) {
        case this.switchType.SCHOONEY_BUS:
          appUrl = this.appUrl?.schoolBusUrl
          break;
        case this.switchType.SCHOONEY_APPLICATION:
          appUrl = this.appUrl?.schoolEnrollUrl
          break;
        case this.switchType.SCHOONEY_TUITION:
          appUrl = this.appUrl?.tuitionUrl
          break;
        default:
          appUrl = this.appUrl?.schooneyUrl
          break;
      }
      if (appUrl) {
        location.href = appUrl
      }

      // Deprecated since required data already been save in localStorage since redirect
      // const formData = {
      //   type: type
      // }

      // this.showMenu = false
      // this.isSubmitting = true
      // const res = await services.getUrlSwitchSystem(formData)
      // if (res && res.data && res.data.status && res.data.status.code === 0) {
      //     location.href = res.data.data.appUrl
      // } else {
      //   alert('error')
      // }
      // this.isSubmitting = false
    },
    goResetPassword () {
      const url = `${this.appUrl.schooneyUrl}/repassword`
      window.location = url
    },
    goLogout () {
      const url = `${this.appUrl.schooneyUrl}/logout`
      window.location = url
    },
    
    goToLineOA () {
        const schooneyUrl = JSON.parse(localStorage.getItem('AppUrl')).schooneyUrl
        window.location = schooneyUrl + "/line/line-oa/registration"
    }
  },
};
</script>

<style scoped lang="scss">
.backoffice__layout {
  min-height: 100vh;
  display: flex;
  /* overflow: hidden; */
}
.backoffice__main {
  flex: 1;
  background-color: #fff;
  /* padding-top: 24px; */
}
.backoffice__header {
  font-size: 28px;
  font-family: "prompt", sans-serif;
  /* border-bottom: 1px solid #d7d6d8; */
  padding: 16px 24px;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}
.backoffice__sidebar {
  background: #fafafd;
  width: 256px;
}

.sidebar {
  font-family: "Prompt", sans-serif;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif;
  }
}

.sidebar .v-list {
  // padding: 0 24px;
}

.sidebar .v-list-item__title {
  white-space: pre-line;
}

.sidebar .v-list-item,
.sidebar > .v-list > .v-list-group > .v-list-item {
  // padding: 0;
  // padding: 12px 0;
}

.sidebar .v-list > div:not(:last-of-type) {
  border-bottom: 1px solid #e4e7f2;
}

.sidebar__menu-item {
  padding: 8px 0;
  font-size: 18px;
  cursor: pointer;
}

.sidebar__logo {
  padding: 32px 24px;
}
.sidebar__title {
  padding: 8px 24px;
  background: #ebebec;
  font-size: 18px;
}
.sidebar__title > p {
  margin-block: 0;
  font-weight: 500;
}
.sidebar__menu-list {
  list-style: none;
  margin-top: 16px;
  padding: 0 24px;
}

.sidebar__menu-item {
  padding: 8px 0;
  font-size: 18px;
  cursor: pointer;
}

.sidebar__menu-item--active,
.sidebar__menu-item--active > .v-icon {
  color: #ff9800;
}

/* override */
.v-list.v-sheet {
  background-color: transparent;
  box-shadow: unset !important;
  margin: 0;
}

.menu > .v-list-item__title {
  font-weight: 500;
  font-size: 18px !important;
}

.menu-active > .v-list-item__title,
.menu-active .v-list-item__title,
.menu-active > .v-list-item__icon > .v-icon {
  color: var(--color-primary);
}

.top-bar {
  display: flex;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
}

.top-bar__menu a {
  color: var(--color-black);
}

.top-bar__menu {
  font-family: "prompt", sans-serif;
  font-weight: 300;
  display: flex;
  gap: 16px;
  align-items: center;
}

.top-bar__menu > a {
  cursor: pointer;
}

.dropdown-menu {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px;
  box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
  border-radius: 10px !important;
  background-color: var(--color-white);
}
.dropdown-menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
a.dropdown-menu-item {
  color: var(--color-black) !important;
}

.dropdown-menu-list {
  padding: 16px;
  box-shadow: 0px 0px 20px rgba(232, 232, 232, 0.7) !important;
  border-radius: 10px !important;
  background-color: var(--color-white);
}
.dropdown-menu-list > ul {
  list-style: none;
  padding-left: 0;
}

.dropdown-menu-list > ul > li {
  padding: 4px 0;
}
.dropdown-menu-list > ul > li > a {
  color: var(--color-black);
  display: flex;
  align-items: center;
  gap: 4px;
}

.menu-icon {
  font-size: 24px !important;
  color: #37323c !important;
}

.user__avatar {
  position: relative;
}

.user__badge {
  position: absolute;
  top: -1px;
  right: -1px;
  display: block;
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  background-color: #00c487;
  border-radius: 5px;
  border: 1px solid #fff;
}
.line-oa-tutorial {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 170px;
    height: 42px;
    border: 1px solid #D7D6D8;
    border-radius: 8px;
    margin-right: 1rem;
    cursor: pointer;
    user-select: none;
    transition: .1s all;
}
.line-oa-tutorial:hover {
    background-color: rgb(248, 248, 248);
}
.line-oa-tutorial:active {
    background-color: whitesmoke;
}
</style>
